import React from "react";

const ITEMS = [
  "Brand Strategy",
  "Creative Direction",
  "Visual Identity",
  "Packaging",
  "Landing Pages",
  "Presentation Design",
  "AI Creative Workflows",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="py-8 md:py-10 border-y border-charcoal/10 bg-charcoal overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-heading italic text-cream/90 text-3xl md:text-5xl px-6 md:px-10">
              {item}
            </span>
            <span className="text-gold text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
